export const CSRF_TOKEN_STORAGE_KEY = '_csrfToken';

export function storeCsrfToken(token: string): void {
    sessionStorage.setItem(CSRF_TOKEN_STORAGE_KEY, token);
}

export function loadCsrfToken(): string | undefined {
    return sessionStorage.getItem(CSRF_TOKEN_STORAGE_KEY) || undefined;
}
